module.exports = __webpack_public_path__ + "static/img/active-rule-content-bg.c0705c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active-rule-content-bg.png
// module id = RUEF
// module chunks = 0